import { createFileRoute } from '@tanstack/react-router'
import { useRouteDigitalProductId } from '@/shared/hooks/useRouteDigitalProductId'

import { DigitalProductJourneyLevelPlay } from '@/features/journeys/Levels/Play'

export const Route = createFileRoute('/_event/niveis/$levelId/iniciar')({
  component: DigitalProductStandaloneLevelPlayPage
})

function DigitalProductStandaloneLevelPlayPage() {
  const digitalProductId = useRouteDigitalProductId()
  const { levelId } = Route.useParams()

  return (
    <DigitalProductJourneyLevelPlay
      digitalProductId={digitalProductId}
      id={levelId}
    />
  )
}
